/**
 * Fetch content from S3, for JSON, CSS, and translations.
 *
 * Sets cache-control to no-cache, and falls back to the live folder if not found in the internal folder.
 *
 * @param path
 * @returns
 */
export const fetchContent = (path: string): Promise<string> =>
  fetch(path, { cache: 'no-cache' })
    .then(r =>
      r.ok
        ? r.text()
        : path.includes('/content/internal/')
          ? fetchContent(path.replace('/content/internal/', '/content/live/'))
          : Promise.reject('')
    )
    .catch(() => {
      return Promise.reject('');
    });

export default fetchContent;
